import { render } from "./ResetTooltip.vue?vue&type=template&id=756fe0eb"
import script from "./ResetTooltip.vue?vue&type=script&lang=js"
export * from "./ResetTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/home/timecard-prod/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__